export class MoveContactUsForm {
    private readonly formName = '[name="name"]';
    private readonly formEmail = '[name="email"]';
    private readonly formRemark = '[name="remark"]';
    private readonly formTelephone = '[name="telephone"]';

    private formNameElement: HTMLInputElement = undefined;
    private formEmailElement: HTMLInputElement = undefined;
    private formRemarkElement: HTMLTextAreaElement = undefined;

    private formData: { [key: string]: string };
    // eslint-disable-next-line max-len
    private static EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    activate(): void {
        this.addEventListeners();
    }

    public submit(event: SubmitEvent, addContactUrl: string): void {
        event.preventDefault();

        if (!this.validateFormBySubmit()) {
            this.formData = {
                name: this.formNameElement.value,
                email: this.formEmailElement.value,
                remark: this.formRemarkElement.value
            };
            const formTelephoneValue = document.querySelector<HTMLInputElement>(this.formTelephone).value;
            if (formTelephoneValue) {
                this.formData = {
                    ...this.formData,
                    telephone: formTelephoneValue
                }
            }
            this.addContact(addContactUrl);
        }
    }

    private addEventListeners() {
        this.formNameElement = document.querySelector(this.formName);
        this.formEmailElement = document.querySelector(this.formEmail);
        this.formRemarkElement = document.querySelector(this.formRemark);

        [this.formNameElement, this.formEmailElement, this.formRemarkElement].forEach((requiredFormElement) => {
            requiredFormElement.addEventListener('keyup', MoveContactUsForm.validateFormElements);
        })
    }

    private validateFormBySubmit(): boolean {
        let validation = false;
        const formEmailValidationError = document.querySelector<HTMLElement>(`#form-email-validation-error`);
        [this.formNameElement, this.formEmailElement, this.formRemarkElement]
            .forEach((requiredFormElement) => {
                const formElementRequiredError = document.querySelector<HTMLElement>
                (`#form-${requiredFormElement.name}-required-error`);

                MoveContactUsForm.showValidationMessage(requiredFormElement, formElementRequiredError);
                if (formElementRequiredError.classList.contains('d-block') || formEmailValidationError.classList.contains('d-block')) {
                    validation = true;
                }
            })

        return validation;
    }

    private addContact(addContactUrls: string): void {
        const params = {
            ...this.formData,
            method_: 'json',
            context_: 'b2c',
        }
        const url = this.getEncodedUrl(addContactUrls, params);
        void fetch(url)
            .then(response => {
                if (response.ok) {
                    document.querySelector<HTMLElement>('form').classList.add('d-none');
                    document.querySelector<HTMLElement>(`#form-thank-you-msg`).classList.remove('d-none');
                }
            })
            .catch(error => {
                console.error(error);
                document.querySelector<HTMLElement>(`#form-request-error`).classList.add('d-block');
            });
    }

    private getEncodedUrl(url: string, params: Record<string, string> = {}): string {
        let encodedUrl = url;
        let separator = encodedUrl.indexOf('?') > -1 ? '&' : '?';
        if (Object.keys(params).length > 0) {
            encodedUrl += separator + Object
                .entries(params)
                .map(([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`).join('&');
        }
        return encodedUrl;
    }

    private static validateFormElements(event: Event): void {
        const element = event.target as HTMLTextAreaElement | HTMLInputElement;
        const formElementRequiredError = document.querySelector<HTMLElement>
        (`#form-${element.name}-required-error`);

        MoveContactUsForm.showValidationMessage(element, formElementRequiredError);
    }

    private static showValidationMessage(formElement: HTMLTextAreaElement | HTMLInputElement, errorContainer: HTMLElement): void {
        const formGroup = errorContainer.closest('.form-group') as HTMLElement;
        const formEmailValidationError = document.querySelector<HTMLElement>(`#form-email-validation-error`);

        if (!formElement.value) {
            MoveContactUsForm.addFailedValidationCSSClasses(formGroup, errorContainer);
            if (formElement.name === 'email') {
                formEmailValidationError.classList.remove('d-block');
            }
        } else {
            if (formElement.name === 'email') {
                errorContainer.classList.remove('d-block');
                if (!MoveContactUsForm.validateFormEmail(formElement.value)) {
                    MoveContactUsForm.addFailedValidationCSSClasses(formGroup, formEmailValidationError);
                } else {
                    MoveContactUsForm.addSuccessValidationCSSClasses(formGroup, formEmailValidationError);
                }

                return;
            }
            MoveContactUsForm.addSuccessValidationCSSClasses(formGroup, errorContainer);
        }
    }

    private static addSuccessValidationCSSClasses(formGroup: HTMLElement, errorContainer: HTMLElement): void {
        errorContainer.classList.remove('d-block');
        formGroup.classList.remove('sd-form-row-invalid');
        formGroup.classList.add('sd-form-row-valid');

    }

    private static addFailedValidationCSSClasses(formGroup: HTMLElement, errorContainer: HTMLElement): void {
        errorContainer.classList.add('d-block');
        formGroup.classList.remove('sd-form-row-valid');
        formGroup.classList.add('sd-form-row-invalid');
    }

    // Taken from https://stackoverflow.com/questions/46155/how-can-i-validate-an-email-address-in-javascript
    private static validateFormEmail(email: string): boolean {
        return this.EMAIL_REGEX.test(email)
    }
}

(<any>window).skyComponents = (<any>window).skyComponents || {};
(<any>window).skyComponents.moveContactUsForm = new MoveContactUsForm();
(<any>window).skyComponents.moveContactUsForm.activate();
